import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {IIndexable} from "../../../../domain/interfaces";
import {getJSONFromHtml} from "../../../../domain/common";
import {AllTagsDM} from "../interfaces";

const PageData = (getJSONFromHtml(document.getElementById('olp-all-tags-data')) as AllTagsDM);
const _imgCdnDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();
const _creatorsPath = (document.getElementById('creators-relative-path')?.textContent || '')?.trim().toLowerCase();

export interface StateInterface extends IIndexable{
    AllTagsData:AllTagsDM;
    imgCdnDomain: string;
    creatorsPath: string;
}
// initial state
const initialState: StateInterface = {
    AllTagsData:PageData,
    imgCdnDomain: _imgCdnDomain,
    creatorsPath:_creatorsPath
}
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

